import IconRocket from '@apollo/icons/default/IconRocket.svg';
import { Button, Card, CardBody, Heading } from '@apollo/orbit';
import { Rocket2 } from '@apollo/space-kit/illustrations/Rocket2';
import React from 'react';
import { Link } from 'react-router-dom';

import { GraphRef } from 'src/app/graph/hooks/useGraphRef';
import { launchesRouteConfig } from 'src/app/graph/routes';

export const NoSchemaFoundForContract = ({
  graphRef,
}: {
  graphRef: GraphRef;
}) => {
  return (
    <Card className="m-8 h-full">
      <CardBody className="items-center justify-center text-center">
        <Rocket2 className="h-32 w-64" />
        <Heading size="3xl">No contract schema found</Heading>
        <div>
          <p>
            Contract schemas are updated when publishes to the source variant
            are made.
          </p>
          <p>Visit the Launches page to get insights on your contract build.</p>
        </div>
        <Button
          size="lg"
          as={Link}
          to={launchesRouteConfig.location({ ...graphRef })}
          leftIcon={<IconRocket />}
        >
          Go to Launch
        </Button>
      </CardBody>
    </Card>
  );
};
